export default "__VITE_ASSET__CxeDaBWY__"